<div *ngIf="this.popOverData?.length > 0; else noFirstValidation" class="d-flex align-items-center h-100">
    <span>{{this.firstParticipant}}</span>
    <div
        id="popover-challenge-${param.rowIndex}"
        #p="ngbPopover"
        [ngbPopover]="popoverLeader"
        triggers="mouseenter:mouseleave"
        (mouseover)="openPopover(p)"
        placement="bottom-left top-left"
        popoverClass="cxone-challenge-tooltip"
        container="body"class="textContent">
        <div id= "pop-${param.rowIndex}" class="pl-1">
            <span class="hover-underline">+ {{this.popOverData?.length}}</span>
        </div>
    </div>
</div>
<ng-template #noFirstValidation>
    <div class="d-flex align-items-center h-100">
        <span>{{this.value ? this.value : "-"}}</span>
    </div>`;
</ng-template>

<ng-template #popoverLeader>
    <div popOverData *ngFor="let leader of popOverData">{{ leader?.Name }}</div>
</ng-template>
